function onClicked(evt) {

	if(evt.target.tagName == "A") {
		return false;
	} else {
		if(this.classList.contains("active")) {
			this.classList.remove("active");
		} else {
			this.classList.add("active");
		}


		evt.preventDefault();
	}
}

module.exports = {
	init() {

		// This behavior was removed for ADA

		// var toggles = document.querySelectorAll(".location-cell");

		// Array.from(toggles).forEach(toggle => {
		// 	toggle.addEventListener("click", onClicked);
		// });
		
	}
}